import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { useRef } from "react";

const LETTERS = ["E", "R", "S", "E", "H"];
const HEIGHTS = ["88%", "100%", "80%", "96%", "86%"];
const ALIGN_END = [false, true, false, true, false];
const COLORS = ["#F2A93B", "#31517E", "#C05A3A", "#2E7D4F", "#A62639"];

export default function CountryClothWeave({ className = "" }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });

  // Pre-compute all 5 parallax transforms at the top level — never inside .map
  const parallaxEven = useTransform(scrollYProgress, [0, 1], [40, -40]);
  const parallaxOdd = useTransform(scrollYProgress, [0, 1], [-30, 30]);
  const parallaxes = [parallaxEven, parallaxOdd, parallaxEven, parallaxOdd, parallaxEven];

  return (
    <div
      ref={ref}
      className={`grid grid-cols-5 gap-[10px] h-[300px] md:h-[460px] ${className}`}
      aria-hidden="true"
    >
      {LETTERS.map((letter, i) => (
        <motion.div
          key={i}
          className="rounded-xl relative overflow-hidden cloth-stripes will-change-transform"
          style={{
            background: COLORS[i],
            height: HEIGHTS[i],
            alignSelf: ALIGN_END[i] ? "end" : "start",
            y: reduce ? 0 : parallaxes[i],
          }}
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1.1, delay: 0.2 + i * 0.11, ease: [0.19, 1, 0.22, 1] }}
        >
          <motion.b
            className="absolute bottom-3 left-0 right-0 text-center font-display text-3xl md:text-4xl text-white/95"
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.9, delay: 0.55 + i * 0.11, ease: [0.19, 1, 0.22, 1] }}
          >
            {letter}
          </motion.b>
        </motion.div>
      ))}
    </div>
  );
}
